import React, { useEffect, useState } from 'react'
import { collection, query, where, orderBy, onSnapshot, updateDoc, doc } from 'firebase/firestore'
import { db } from '../../firebase.config'
import { useAuth } from '../../context/AuthContext'
import AppLayout from '../../components/layout/AppLayout'
import { subscribeToJHAs } from '../../services/jhaService'

const STATUS_COLORS: Record<string, string> = { draft: '#f59e0b', active: '#16a34a', closed: '#1a3c5e' }
const STATUS_LABELS: Record<string, string> = { draft: 'Draft', active: 'Active', closed: 'Closed' }

export default function JHAPage() {
  const { orgId, isSupervisor } = useAuth()
  const [jhas, setJhas] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    const unsub = subscribeToJHAs(orgId, data => { setJhas(data); setLoading(false) })
    return () => unsub()
  }, [orgId])

  const handleApprove = async (id: string) => {
    await updateDoc(doc(db, 'organizations', orgId, 'jha', id), { status: 'Approved', updatedAt: new Date().toISOString() })
  }

  const formatDate = (iso: string) => iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''

  return (
    <AppLayout title="Job Hazard Analysis">
      <div className="mb-6 flex items-center justify-between">
        <input type="text" placeholder="Search JHAs..." className="border border-gray-300 rounded-lg px-4 py-2 text-sm w-64" />
      </div>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Description</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Project</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Hazards</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Status</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Date</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Action</th>
            </tr>
          </thead>
          <tbody>
            {jhas.map(j => (
              <tr key={j.id} className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={() => window.open(`/jha/${j.id}`, '_blank')}>
                <td className="px-5 py-3 font-medium text-gray-900 max-w-xs truncate">{j.taskDescription || j.description}</td>
                <td className="px-5 py-3 text-gray-600">{j.projectName || '-'}</td>
                <td className="px-5 py-3 text-gray-600">{j.hazards?.length || 0}</td>
                <td className="px-5 py-3">
                  <span className="px-2 py-1 rounded text-xs font-medium" style={{ backgroundColor: (STATUS_COLORS[j.status] || '#888') + '20', color: STATUS_COLORS[j.status] || '#888' }}>
                    {STATUS_LABELS[j.status] || j.status || 'Draft'}
                  </span>
                </td>
                <td className="px-5 py-3 text-gray-500">{formatDate(j.createdAt)}</td>
                <td className="px-5 py-3">
                  {j.status === 'active' && isSupervisor() && (
                    <button onClick={() => { const { closeJHA } = require('../../services/jhaService'); closeJHA(orgId, j.id) }} className="text-sm text-blue-600 hover:underline font-medium">Close</button>
                  )}
                </td>
              </tr>
            ))}
            {jhas.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-12 text-center text-gray-400">No JHAs found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppLayout>
  )
}